<script lang="ts">
  import ControlsModal from '$components/Accessibility/Modal/ControlsModal.svelte';
  import Footer from '$components/News/Footer/Footer.svelte';
  import NavbarModal from '$components/Navigation/NavbarModal.svelte';
  import SideRails from '$components/Common/SideRails.svelte';
  import BackgroundGradient from '$components/News/Background/BackgroundGradient.svelte';

  import { page } from '$app/stores';
</script>

<BackgroundGradient>
  <SideRails />
  <slot />
  <Footer document={$page.data.footer} />
</BackgroundGradient>
<NavbarModal document={$page.data.secondaryNavData} />
<ControlsModal />
